import { useInitialState } from '@/hooks';

export const getDictionary = (
  key: string,
  dataType: 'options' | 'valueEnum' = 'options',
): any => {
  const { dictionary } = useInitialState.getState();
  return dictionary?.get(key)?.[dataType];
};
